import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Button";

interface Props {
  label: string;
}

const PromoHeader = ({ label }: Props) => {
  const navigate = useNavigate();

  return (
    <StyledPromoHeader>
      <BackButtonWrapper>
        <Button
          label="Back"
          isRounded={true}
          onClick={() => navigate(-1)}
        />
      </BackButtonWrapper>
      <StyledPageHeader>{label}</StyledPageHeader>
    </StyledPromoHeader>
  );
};

const BackButtonWrapper = styled.div`
  width: 120px;
  @media only screen and (max-width: 768px) {
    padding: 1rem;

  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledPromoHeader = styled.div`
  display: flex;
  padding-bottom: 1rem;
  align-items:center;
  gap:1rem;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0;
  }
`;

export default PromoHeader;
